import { ReactNode } from 'react';
import Container from '@v2/shared/components/Container';
import FaqAccordion from '@v2/shared/components/FaqAccordion';

const LINK_CLASS = 'text-red-600 underline hover:text-red-500 active:text-red-900';

/** The "view all magazines" page, which is still headless_jshop's. */
const BROWSE_URL = '/categories/zinio-unlimited';

type Faq = {
  question: string;
  answer: ReactNode;
};

const FAQS: Faq[] = [
  {
    question: 'What is ZINIO Unlimited?',
    answer:
      'DiscountMags has partnered with Zinio to offer "ZINIO Unlimited". It is an all you can read digital magazine platform. Once you subscribe, it allows you instant access to read over 5,000 digital magazines on the ZINIO Unlimited platform.',
  },
  {
    question: 'Advantages of ZINIO Unlimited?',
    answer:
      "Your subscription will allow you to access all magazines on the ZINIO Unlimited platform, without restrictions. Access 5,000+ magazines. It includes a wide variety of magazines that will suit anyone's interests. From sport to fashion, from food to culture, with everything in between.",
  },
  {
    question: 'Which magazines are included?',
    answer: (
      <p>
        ZINIO Unlimited includes over 30,000 issues from 5,000+ digital magazines. Visit our{' '}
        <a href={BROWSE_URL} className={LINK_CLASS}>
          available magazines page
        </a>{' '}
        to browse all the available titles.
      </p>
    ),
  },
  {
    question: 'Which devices are compatible with ZINIO Unlimited?',
    answer:
      'You can read anywhere/anytime, online or offline, on your iPad, iPhone, Android, PC or Mac. Enjoy its multi device accessibility.',
  },
  {
    question: 'How many different devices can I use this on at one time?',
    answer: 'You can access ZINIO Unlimited on up to 5 devices at a time.',
  },
  {
    question: 'Can I cancel my subscription?',
    answer: (
      <p>
        Absolutely, there is no commitment and you can cancel your subscription anytime via your{' '}
        <a href="/customer?xCmd=account" className={LINK_CLASS}>
          account page
        </a>
        . If you are having trouble logging into your account, you can always{' '}
        <a href="/contact?xSubject=32" className={LINK_CLASS}>
          contact us
        </a>{' '}
        to request the cancellation.
      </p>
    ),
  },
  {
    question: 'Do you have any more questions?',
    answer: (
      <p>
        Please do not hesitate to{' '}
        <a href="/contact?xSubject=32" className={LINK_CLASS}>
          contact our customer support
        </a>
        . We will be happy to help you.
      </p>
    ),
  },
];

export default function FaqPanel() {
  return (
    <div className="flex justify-center bg-slate-100 py-10 md:py-12 lg:py-20">
      <Container className="flex flex-col items-center justify-center">
        <h2 className="text-3xl md:text-4xl mb-10 font-bold text-center">Frequently Asked Questions</h2>
        {FAQS.map((faq) => (
          <FaqAccordion key={faq.question} question={faq.question} answer={faq.answer} className="mb-3" />
        ))}
      </Container>
    </div>
  );
}
